export const careUserType = {
  cargiver: 'CAREGIVER',
  careRecipient: 'CARE_RECIPIENT',
  professional_caregiver: 'PROFESSIONAL_CAREGIVER',
};

export const CARE_CIRCLE_RELATION_STATUS = { active: 'active', cancelled: 'cancelled', pending: 'pending' };

export const MEDICATION_STATUS = { completed: 'COMPLETED', pending: 'PENDING', cancelled: 'CANCELLED' };

export const SUBSCRIPTION_TYPE = { device: 'DEVICE_PLAN', can_companion: 'CAN_COMPANION', emergency: 'EMERGENCY' };

export const MESSAGE_TYPE = { text: 'text', voice: 'voice', photo: 'photo', video: 'video' };
export const ICON_BUTTON_TYPE = {
  close: 'close',
  edit: 'edit',
  delete: 'delete',
  download: 'download',
  eye: 'eye',
  share: 'share',
  send: 'send',
  forward: 'forward',
  menu: 'menu',
};

export const ALLOWED_FILES_DOC = {
  documents: [
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/docx',
    'application/docs',
    'image/jpg',
    'image/jpeg',
  ],
  videos: ['video/mp4'],
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const MAX_VIDEO_SIZE = 10 * 1024 * 1024;

export const INSURANCE_COMPANIES = [
  'UnitedHealth Group',
  'Humana',
  'Aetna',
  'Blue Cross and Blue Shield Association',
  'Amerigroup',
  'Bright Health',
  'CareSource',
  'Health Net',
];

export const INSURANCE_COMPANIES_IMAGE = {
  [INSURANCE_COMPANIES[0]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnxVDDFwArslkItyzwKm03aCF_doI6P2E-zQ&s',
  [INSURANCE_COMPANIES[1]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDlD2yWrXRPvsiVAS752l9KhP_ChRhSEsagA&s',
  [INSURANCE_COMPANIES[2]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIjf1et_SkkVbDt-fJ8QrIfpm_ueIAh-7FkQ&s',
  [INSURANCE_COMPANIES[3]]:
    'https://www.thefreedomcenter.com/wp-content/uploads/2023/09/Blue-Cross-Blue-Shield-Drug-Rehab.png',
  [INSURANCE_COMPANIES[4]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4D4-DzGiVg4fa9O4mm4IbV_xXTqraYo_aKQ&s',
  [INSURANCE_COMPANIES[5]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSujUEx6Vv6r8fJDS7C0_yVhAGjyiNl8UHt8g&s',
  [INSURANCE_COMPANIES[6]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPKO6LcLlfbuz09q9ln1rHb3yDpGvYmkLLLw&s',
  [INSURANCE_COMPANIES[7]]:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBcMCrlLh8EnruOHh3rOY9BzmwF_lh6jeJug&s',
};

export const RELATIONS = [
  'Grand Father',
  'Grand Mother',
  'Father',
  'Mother',
  'Sister',
  'Brother',
  'Spouse',
  'Son',
  'Daughter',
  'Friend',
  'Professional Caregiver',
];
export const VITAL_CHART_TYPES = {
  'Blood Pressure': 'BLOOD_PRESSURE',
  'Heart Rate': 'HEART_RATE',
  Calories: 'CALORIES_BURNED',
  Glucose: 'GLUCOSE',
};

export const VITAL_CHART_LABELS = {
  BLOOD_PRESSURE: { label: 'Blood Pressure', unit: 'mmHg' },
  HEART_RATE: { label: 'Heart Rate', unit: 'bpm' },
  CALORIES_BURNED: { label: 'Calories Burned', unit: 'kcal' },
  GLUCOSE: { label: 'Glucose', unit: 'mg/dL' },
};
export const TAB_MENU = ['Vitals', 'Activities', 'Fall detection', 'Gait Speed'];

export const VITALS_TAB_MENU = [
  'Heart Rate',
  'Blood Pressure',
  'Calories',
  'Glucose',
  // 'Body Temperature',
  // 'Respiratory Rate',
  // 'Oxygen Saturation',
  // 'Stride length',
];

export const ACTIVITIES_TAB_MENU = [
  { name: 'Distance', percentage: '65%' },
  { name: 'Steps', percentage: '85%' },
  { name: 'Sleep', percentage: '75%' },
];
export const ACTIVITIES_CHART_TYPES = {
  Distance: 'DISTANCE_TRAVELLED',
  Steps: 'STEPS',
  Sleep: 'SLEEP',
};
export const ACTIVITIES_CHART_LABELS = {
  DISTANCE_TRAVELLED: { label: 'Distance', unit: 'm' },
  STEPS: { label: 'Steps', unit: 'steps' },
  SLEEP: { label: 'Sleep', unit: 'minutes' },
};
export const HEALTH_OVERVIEW_MODAL_TYPES = {
  'Heart Rate': {
    type: 'HEART_RATE',
    unit: 'BEATS_PER_MINUTE',
  },
  'Blood Pressure': {
    type: 'BLOOD_PRESSURE_DIASTOLIC',
    type2: 'BLOOD_PRESSURE_SYSTOLIC',
    unit: 'MILLIMETER_OF_MERCURY',
  },
  'Glucose Levels': {
    type: 'GLUCOSE_LEVELS',
    unit: 'MILLIGRAM_PER_DECILITER',
  },
  'Body Temperature': {
    type: 'BODY_TEMPERATURE',
    unit: 'DEGREE_CELSIUS',
  },
  'Respiratory Rate': {
    type: 'RESPIRATORY_RATE',
    unit: 'BREATHS_PER_MINUTE',
  },
  'Oxygen Saturation': {
    type: 'OXYGEN_SATURATION',
    unit: 'PERCENTAGE',
  },
  'Stride length': {
    type: 'STRIDE_LENGTH',
    unit: 'METER',
  },
  'Gait Speed': {
    type: 'GAIT_SPEED',
    unit: 'METER_PER_HOUR',
  },
  Distance: {
    type: 'DISTANCE_TRAVELLED',
    unit: 'METER',
  },
  Steps: {
    type: 'STEPS',
    unit: 'COUNT',
  },
  Calories: {
    type: 'CALORIES_BURNED',
    unit: 'KILOCALORIE',
  },
  Sleep: {
    type: 'SLEEP',
    unit: 'MINUTES',
  },
};
